import { render, staticRenderFns } from "./SubjectsCustomizing.vue?vue&type=template&id=00d01128&scoped=true"
import script from "./SubjectsCustomizing.vue?vue&type=script&lang=js"
export * from "./SubjectsCustomizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d01128",
  null
  
)

export default component.exports